module.exports = __webpack_public_path__ + "img/twitter-social-media-icon-design-template-vector-png_127015-removebg-preview.b9a3c386.png";